// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3OtSL","error":"Textarea_error__oujIM","readonly":"Textarea_readonly__3BBCP","disabled":"Textarea_disabled__1W52j"};